<template>
  <div class="historyIndex">
    <div class="contrast">
        <div class="sym">
            <p>欧指对比</p>
            <p>低</p>
            <p>中</p>
            <p>高</p>
        </div>
        <div class="scor">
            <p>本届</p>
            <p><span>{{turnData[2].current.left.count}}场</span>({{turnData[2].current.left.rate}})</p>
            <p><span>{{turnData[2].current.middle.count}}场</span>({{turnData[2].current.middle.rate}})</p>
            <p><span>{{turnData[2].current.right.count}}场</span>({{turnData[2].current.right.rate}})</p>
        </div>
        <div class="scor" style="background-color:#fff">
            <p>近三届</p>
            <p><span>{{turnData[2].history.left.count}}场</span>({{turnData[2].history.left.rate}})</p>
            <p><span>{{turnData[2].history.middle.count}}场</span>({{turnData[2].history.middle.rate}})</p>
            <p><span>{{turnData[2].history.right.count}}场</span>({{turnData[2].history.right.rate}})</p>
        </div>
    </div>
    <div class="contrast">
        <div class="sym">
            <p>亚指对比</p>
            <p>上</p>
            <p>走</p>
            <p>下</p>
        </div>
        <div class="scor">
            <p>本届</p>
            <p><span>{{turnData[1].current.left.count}}场</span>({{turnData[1].current.left.rate}})</p>
            <p><span>{{turnData[1].current.middle.count}}场</span>({{turnData[1].current.middle.rate}})</p>
            <p><span>{{turnData[1].current.right.count}}场</span>({{turnData[1].current.right.rate}})</p>
        </div>
        <div class="scor" style="background-color:#fff">
            <p>近三届</p>
            <p><span>{{turnData[1].history.left.count}}场</span>({{turnData[1].history.left.rate}})</p>
            <p><span>{{turnData[1].history.middle.count}}场</span>({{turnData[1].history.middle.rate}})</p>
            <p><span>{{turnData[1].history.right.count}}场</span>({{turnData[1].history.right.rate}})</p>
        </div>
    </div>
    <div class="contrast">
        <div class="sym">
            <p>大小对比</p>
            <p>大</p>
            <p>走</p>
            <p>下</p>
        </div>
        <div class="scor">
            <p>本届</p>
            <p><span>{{turnData[3].current.left.count}}场</span>({{turnData[3].current.left.rate}})</p>
            <p><span>{{turnData[3].current.middle.count}}场</span>({{turnData[3].current.middle.rate}})</p>
            <p><span>{{turnData[3].current.right.count}}场</span>({{turnData[3].current.right.rate}})</p>
        </div>
        <div class="scor" style="background: #ffffff;">
            <p>近三届</p>
            <p><span>{{turnData[3].history.left.count}}场</span>({{turnData[3].history.left.rate}})</p>
            <p><span>{{turnData[3].history.middle.count}}场</span>({{turnData[3].history.middle.rate}})</p>
            <p><span>{{turnData[3].history.right.count}}场</span>({{turnData[3].history.right.rate}})</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['turnData'],
    name: 'historyIndex',
    mounted () {
    }
}
</script>

<style lang="less" scoped>
.historyIndex {
    padding: 40/2px 20/2px;
    .contrast {
        overflow: hidden;
        border-radius: 8/2px;
        position: relative;
        margin-bottom: 40/2px;
        border: 1/2px solid rgba(99,122,133,0.4);;
        .sym {
            height: 58/2px;
            background: #FFFFFF;
            display: flex;
            p {
                flex: 1;
                font-size: 24/2px;
                font-weight: 400;
                color: #637A85;
                border-left: 1/2px solid rgba(99,122,133,0.4);
                line-height: 58/2px;
                &:first-child{
                    border-left: 0;
                    line-height: 26/2px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
        .scor {
            height: 70/2px;
            display: flex;
            align-items: center;
            border-top: 1/2px solid rgba(99,122,133,0.4);
            p {
                flex: 1;
                font-size: 24/2px;
                font-weight: 400;
                color: #637A85;
                border-left: 1/2px solid rgba(99,122,133,0.4);
                line-height: 70/2px;
                &:first-child {
                    width: 90/2px;
                    font-size: 28/2px;
                    font-weight: 400;
                    color: #637A85;
                    border-left: none;
                    line-height: 32/2px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                span {
                    font-size: 28/2px;
                    color: #1A313C;
                }
            }
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
